// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { sanitizeLink } from './string';
import RNFS from 'react-native-fs';
import FileViewer from 'react-native-file-viewer';
import { Platform } from 'react-native';

export const getExtension = (name: string) => {
  return name.split('.').pop();
};

/**
 * Formats size in bytes to human readable formats
 * @param size Size in bytes
 * @returns Human readable file size
 */

export const getFileSize = (size: number) => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / 1024 ** i).toFixed(2)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

/**
 * Extracts the file name from a URL.
 * @param link The URL of the file
 * @param fallback Fallback filename
 * @returns File name
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getFileName = (link: string, fallback: string = 'file') => {
  const url = new URL(link);
  const name = decodeURIComponent(url.pathname.split('/').pop());
  return name !== '/' ? name : fallback;
};

/**
 * Todo: Implement download logic
 * Downloads file from a given URL without leaving the current page
 * @param link URL of the file to download
 * @param options Optional Options for file download - `name` and `fallbackName`
 */

export const downloadFile = async (
  link: string,
  options?: { name?: string; fallbackName?: string }
) => {
  const downloadDest =
    Platform.OS === 'android'
      ? RNFS.DocumentDirectoryPath + '/' + options.name
      : RNFS.DocumentDirectoryPath + '/' + options.name;
  const fileOptions = {
    fromUrl: link,
    toFile: downloadDest,
  };
  await RNFS.downloadFile(fileOptions).promise.then((_res) => {
    FileViewer.open(downloadDest, {
      showOpenWithDialog: true,
      showAppsSuggestions: true,
    });
  });
};
